// 
// -----------------------------------------------------------------------------
(function ($close) {
	if ($close.length === 0) {return false;}

	$close.on('click', function(){
		$(this).closest('.shoppcart-item').animate({
		    opacity: 0,
		  }, 300, function() {
		    $(this).animate({
		    	height: 0,
		    	paddingTop: 0,
		    	paddingBottom: 0
		    }, 300, function(){
		    	$(this).remove();
		    });
		  });
	});

})($( '.close-item' ));